import api from "@/lib/api";
import { toast } from "sonner";

// Resize + center-crop an image file into a square JPEG data URL (keeps payload small).
export function resizeImageFile(file, size = 256) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext("2d");
        const min = Math.min(img.width, img.height);
        const sx = (img.width - min) / 2;
        const sy = (img.height - min) / 2;
        ctx.drawImage(img, sx, sy, min, min, 0, 0, size, size);
        resolve(canvas.toDataURL("image/jpeg", 0.85));
      };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

// Opens a native file picker, uploads the chosen photo, updates auth context. Returns updated user or null.
export function changeAvatar(setUser, t) {
  const tr = typeof t === "function" ? t : (_k, fb) => fb;
  return new Promise((resolve) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/png,image/jpeg,image/webp,image/*";
    input.onchange = async () => {
      const file = input.files && input.files[0];
      if (!file) return resolve(null);
      try {
        const dataUrl = await resizeImageFile(file, 256);
        const { data } = await api.put("/me/avatar", { avatar: dataUrl });
        setUser(data);
        toast.success(tr("avatar.updated", "Photo de profil mise à jour"));
        resolve(data);
      } catch (e) {
        toast.error(e?.response?.data?.detail || tr("avatar.error", "Échec de la mise à jour de la photo"));
        resolve(null);
      }
    };
    input.click();
  });
}
